import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IModulePartnerEditItem extends IEditItem {
    partnerCompanyId: string;
    partnerCompanyCode: string;
    partnerCompanyName: string;
    partnerCompanyLogo: string;
    unitId: string;
    unitCode: string;
    modifyUser: IModifyUser;
}

export class ModulePartnerEditItem extends EditItem implements IModulePartnerEditItem {
    partnerCompanyId: string;
    partnerCompanyCode: string;
    partnerCompanyName: string;
    partnerCompanyLogo: string;
    unitId: string;
    unitCode: string;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IModulePartnerEditItem);
    constructor(obj?: any) {
        super(obj);
        this.partnerCompanyId = obj && obj.partnerCompanyId || "";
        this.partnerCompanyCode = obj && obj.partnerCompanyCode || "";
        this.partnerCompanyName = obj && obj.partnerCompanyName || "";
        this.partnerCompanyLogo = obj && obj.partnerCompanyLogo || "";
        this.unitId = obj && obj.unitId || "";
        this.unitCode = obj && obj.unitCode || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}